import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RecipientGroup } from './message';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var MessageService = /** @class */ (function () {
    function MessageService(_http, _global) {
        this._http = _http;
        this._global = _global;
    }
    MessageService.prototype.findRecipientByProperty = function (PropertyId) {
        var api = _GlobalNS.api.message.send;
        var noteId = this._global.find(_GlobalNS.paths.noteId);
        return this._http.get(api + "&Property_Id=" + PropertyId + "&note_Id=" + noteId, {});
    };
    MessageService.prototype.addMessage = function (message, PropertyId) {
        var api = _GlobalNS.api.message.send;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&Property_Id=" + PropertyId + "&eqrf=" + eqrf, message);
    };
    MessageService.ngInjectableDef = i0.defineInjectable({ factory: function MessageService_Factory() { return new MessageService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: MessageService, providedIn: "root" });
    return MessageService;
}());
export { MessageService };
